import { createHead } from '@unhead/vue';
import { createApp } from 'vue';
import { AppEnvironment } from '@pn/common';
import { sentryClientInit } from '@pn/vue-sentry';
import App from './App.vue';
import router from './router';
import store from './store';
import '@/assets/scss/app.scss';
import 'virtual:svg-icons-register';

const app = createApp(App);
const head = createHead();

const { __SENTRY_DSN__: SENTRY_DSN, __APP_RELEASE__: APP_RELEASE } = window as typeof window & {
  readonly __SENTRY_DSN__: string;
  readonly __APP_RELEASE__: string;
};

if (SENTRY_DSN) {
  sentryClientInit(app, router, SENTRY_DSN, import.meta.env.MODE as AppEnvironment, APP_RELEASE);
}

app.use(head);
app.use(router);
app.use(store);

app.mount('#app');
